const socialBarServices = [{
  icon: 'twitter',
  label: 'Twitter',
  bgColor: '#1da1f2',
  url: (url) => {
    return `https://twitter.com/intent/tweet/?text=&url=${url}`
  }
}, {
  icon: 'facebook',
  label: 'Facebook',
  bgColor: '#1877f2',
  url: (url) => {
    return `https://facebook.com/sharer/sharer.php?u=${url}`
  }
}, {
  icon: 'pinterest',
  label: 'Pinterest',
  bgColor: '#bd081c',
  url: (url) => {
    return `https://pinterest.com/pin/create/button/?url=${url}`
  }
}, {
  icon: 'linkedin',
  label: 'LinkedIn',
  bgColor: '#007bb5',
  url: (url) => {
    return `https://www.linkedin.com/shareArticle?mini=true&url=${url}`
  }
}, {
  icon: 'xing',
  label: 'Xing',
  bgColor: '#026466',
  url: (url) => {
    return `https://www.xing.com/app/user?op=share;title=;url=${url}`
  }
}, {
  icon: 'reddit',
  label: 'Reddit',
  bgColor: '#ff4400',
  url: (url) => {
    return `https://reddit.com/submit/?url=${url}`
  }
}, {
  icon: 'whatsapp',
  label: 'WhatsApp',
  bgColor: '#25d366',
  url: (url) => {
    return `whatsapp://send?text=${encodeURIComponent(window.document.title)} ${url}`
  }
}, {
  icon: 'email',
  label: 'Email',
  bgColor: '#ff4000',
  url: (url) => {
    return `mailto:?subject=${encodeURIComponent(window.document.title)}&body=${url}`
  }
}]

export default socialBarServices



// WEBPACK FOOTER //
// ./src/helpers/social-bar-services.js